import { createFileRoute } from '@tanstack/react-router';
import { InfoPage } from '../components/InfoPage.js';

export const Route = createFileRoute('/contact-us')({
  component: () => <InfoPage title="Contact Us" />,
});
